<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="إسلام-نمر-الجمل">
<h1><span dir="rtl">إسلام نمر الجمل</span></h1>
<p style="text-indent:0em !important"><span dir="rtl">إسلام نمر الجمل، كاتبة وروائية أردنيَّة مِن أصول فلسطينية، مقيمة في الإمارات.</span></p><br/>
<p style="text-indent:0em !important"><span dir="rtl">وُلِدَت وتلقَّت تعليمها الجامعي في الأردن، وقامت بصقل موهبتها بالكتابة مِن خلال دورات مكثَّفة في فن الرواية، وشاركَت في عدَّة مسابقات للأدب على مستوى الدولة.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?c44e1bda